import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { FF_APP_VIEW_SEPARATION, FF_DASHBOARD_TOOL_TABS } from '@/consts/featureFlags';

/**
 * Whether the dashboard lists workflows and tools together. Every gate reads this one answer —
 * splitting them once let rows get tagged while the control explaining the tags did not render.
 *
 * Needs both flags: off `app-view-separation` the server resolves no tool shares, so there is no
 * second kind to tag. `=== true` because an unresolved flag is the off state, not a maybe.
 */
export const useToolTabsEnabled = (): boolean => {
  const { value: isToolViewEnabled } = useFeatureFlag(FF_APP_VIEW_SEPARATION);
  const { value: areTabsEnabled } = useFeatureFlag(FF_DASHBOARD_TOOL_TABS);
  return areTabsEnabled === true && isToolViewEnabled === true;
};
